import { FC, lazy, Suspense, ComponentProps } from 'react';

const PdpSharedRareFindPillLazyComponent = lazy(
    () => import(/* webpackChunkName: "PdpSharedShippingBadge" */ './PdpSharedRareFindPill')
);

export const PdpSharedRareFindPillLazy: FC<
    ComponentProps<typeof PdpSharedRareFindPillLazyComponent>
> = props => (
    <Suspense fallback="">
        <PdpSharedRareFindPillLazyComponent {...props} />
    </Suspense>
);
